export const env = {
  SECRET_KEY:
    "71e1518c1cc9c5ffca9f68bb813b8fbf9d90008be91da2fc2f830d42b61633d887ec05cadbdbc9ec9ee168cf4b7b3846c7619f027db5c5b1339e2105826ba465",
  // BASE_URL: "http://localhost:5000/",
  // BASE_URL: "https://tronlive-club.herokuapp.com/"
  BASE_URL: "https://murmuring-dusk-30425.herokuapp.com/"
};
